import { QRFC } from "./QRFC";
import { Globals } from "./Globals";
import { appstr } from "../utils/appstr";
import { gSupportEmail } from "../whitelabel/brand";

export class QCheckForUpdatesRFC extends QRFC {
  constructor() {
    super();
  }

  InitCheckForUpdates(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, user, planID) {
    this.AddParameter("data", planID);
    this.AddParameter("mode", "PollForPlanChanges");
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
  }

  DoTransactionComplete(response, planMgr) {
    var r = this.SafeParseResponse(response, error => {
      planMgr.AbortPlanningMode({
        errorCode: error.code
      });
    });

    if (!r) return; // Parse failed, abort was called

    var success = r["success"];
    if (!success) {
      planMgr.AbortPlanningMode({ errorCode: r["code"] });
      return;
    }

    var data = r["data"] || {};
    var overrideChange = data["overridemd5"] !== planMgr.GetOverrideHash();
    var talentPoolChange = data["talentPoolmd5"] !== planMgr.GetTalentPoolHash();
    var planSubmissionChange = data["planSubmissionmd5"] !== planMgr.GetPlanSubmissionHash();
    var formulaChange = data["formulaTimestamp"] !== planMgr.GetFormulaTimestamp();
    var syncMismatch = planMgr.fPlanInfo && data["syncDate"] !== planMgr.fPlanInfo["syncDate"];

    var planInfoChangedKeys = null;
    if (r["planInfo"]) {
      planInfoChangedKeys = planMgr.UpdatePlanInfoFromResponse(r["planInfo"]);
    }

    planMgr.SetIsRecalculatingFormulas(data["recalculatingFormulas"] === true);

    if (r["users"] && planMgr.fPlanInfo) {
      planMgr.fPlanInfo["users"] = r["users"];
    }

    planMgr.UpdateContext();

    if (planInfoChangedKeys) {
      if (planMgr.fWSMgr) {
        if (planInfoChangedKeys.includes("name")) {
          var docMgr = planMgr.fWSMgr.GetDocMgr();
          if (docMgr) {
            docMgr.SetFileName(planMgr.GetPlanName());
          }
        }
        /* TODO toasts to user to indicate plan config has changed */
        /*
        planMgr.fWSMgr.BroadcastTopic("add-toast", {
          message: appstr("planconfigupdated"),
          type: "info"
        });
         */
      }
    } else if (syncMismatch) {
      if (planMgr.fWSMgr) {
        planMgr.fWSMgr.OpenPlan(planMgr.GetPlanID());
      }
    } else if (overrideChange || formulaChange) {
      var doc = planMgr.fWSMgr && planMgr.fWSMgr.GetDoc();
      if (!doc) return;
      var scm = doc.GetSubChartMgr();
      var sc = scm.GetActiveSubChart();
      var subRef = sc.GetTopDBObjRef();

      var needScQuery = true;
      for (var i = 0; i < Globals._rfcMgr.QueueSize(); i++) {
        var pendingRFC = Globals._rfcMgr.GetIndexRFC(i);
        if (pendingRFC.GetCallName() === "qquerysvrchart") needScQuery = false;
      }
      if (needScQuery) {
        doc.DoChartDataQuery(subRef, null);
      }
    } else if (talentPoolChange) {
      planMgr.PollTalent();
    } else if (planSubmissionChange) {
      planMgr.LoadPlanSubmission();
    }
  }

  DoSessionEnded() {
    var planMgr = this.fCallBackObj;
    if (planMgr) planMgr.ClosePlanManager();
  }
}
